/** Russian UI copy for SETONE SOUNDS. */
export const ru = {
  root: 'Root',
  breadcrumb: 'Навигация',
  folders: 'Папки',
  collapse: 'Свернуть',
  expand: 'Развернуть',
  foldersLoadFailed: 'Не удалось загрузить папки',

  name: 'Имя',
  duration: 'Длительность',
  format: 'Формат',
  size: 'Размер',
  play: 'Играть',
  download: 'Скачать',
  showInFolder: 'Открыть папку',
  loadMore: 'Ещё',
  loading: 'Загрузка…',
  loadFailed: 'Не удалось загрузить',
  noFiles: 'Нет файлов',
  folderEmpty: 'В этой папке пусто.',

  noMatches: 'Ничего не найдено',
  emptyFolder: 'Пустая папка',
  tryDifferentQuery: 'Попробуйте другой запрос.',
  selectFolder: 'Выберите папку слева или откройте Root.',
  requestFailed: 'Ошибка запроса',
  searchingSounds: 'Ищем звуки…',
  aiSearch: 'ИИ-поиск',
  fileSearch: 'Поиск файлов',
  logout: 'Выйти',

  searchMode: 'Режим поиска',
  files: 'Файлы',
  ai: 'ИИ',
  searchFilenames: 'Поиск по имени файла…',
  searchDescribe: 'Опишите звук… и нажмите Enter',
  search: 'Найти',
  aiHistory: 'История ИИ',
  aiHistoryEmpty: 'Пока нет сохранённых запросов',
  aiHistoryClear: 'Очистить',
  aiHistoryCached: 'из кэша',
  aiHistorySaved: 'сохранено',
  removeFromHistory: 'Удалить из истории',

  noTrack: 'Трек не выбран',
  previous: 'Предыдущий',
  next: 'Следующий',
  pause: 'Пауза',
  mute: 'Выкл. звук',
  unmute: 'Вкл. звук',
  waveform: 'Волна',

  checkingSession: 'Проверка сессии…',
  signIn: 'Вход',
  signInTitle: 'Войти',
  signInHint: 'Закрытая библиотека SFX для Setone Games',
  username: 'Логин',
  password: 'Пароль',
  signingIn: 'Вход…',
  tooManyAttempts: 'Слишком много попыток. Попробуйте позже.',
  invalidCredentials: 'Неверный логин или пароль',

  somethingWrong: 'Что-то пошло не так',
  tryAgain: 'Повторить',
  close: 'Закрыть',

  findInFile: 'Найти в файле…',
  wrap: 'Перенос',
  copy: 'Копировать',
  copied: 'Скопировано',
  copyFailed: 'Не удалось скопировать',
  cannotOpenFile: 'Не удалось открыть файл',
  failedLoadText: 'Не удалось загрузить текст',
  textFile: 'Текстовый файл',
  fileExceedsPreview: (size: string) =>
    `Файл больше лимита превью (${size}). Показана только начальная часть.`,
  relevance: 'Релев.',
} as const;
